import axios from 'axios'

// Create axios instance with base configuration
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5000/api',
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)


const bookingService = {



async getUserBookings(params = {}) {
  try {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(`/bookings/get-user-bookings?${queryString}`);
    return response.data;
  } catch (error) {
    console.error('Error getting user bookings:', error);
    throw error;
  }
},

  async getUserExperienceBookings(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await api.get(`/bookings/get-experience-bookings?${queryString}`);
      return response.data;
    } catch (error) {
      console.error('Error getting experience bookings:', error);
      throw error;
    }
  },

async getDashboardStats() {
  try {
    const response = await api.get(`/bookings/dashboard-stats`);
    return response.data;
  } catch (error) {
    console.error('Error getting dashboard stats:', error);
    throw error;
  }
},

async cancelBooking(confirmationId,cancellationReason) {
  try {
    const response = await api.post(`/checkout/cancel-booking/${confirmationId}/${cancellationReason}`);
    return response;
  } catch (error) {
    console.error('Error cancelling booking:', error);
    throw error;
  }
},

// Experience Cancel Booking - commented out
// async cancelExperienceBooking(bookingReference, reason) {
//   try {
//     const response = await api.post(`/experience-checkout/cancel-booking/${bookingReference}`, {
//       reason: reason || 'No reason provided'
//     });
//     return response;
//   } catch (error) {
//     console.error('Error cancelling experience booking:', error);
//     throw error;
//   }
// },

async getEnvironmentImpact(confirmationId) {
  try {
  
    const response = await api.get(`/bookings/get-environmental-impact-stats/${confirmationId}`);
    return response.data;
  } catch (error) {
    console.error('Error getting user bookings:', error);
    throw error;
  }
},

async getClientEnvironmentalImpact(clientId, startDate, endDate){
  try {
    const response = await api.get('/bookings/client-environmental-impact', {
      params: { clientId, startDate, endDate }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}


}

export default bookingService


export const {
    getUserBookings,
    getDashboardStats
} = bookingService